// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"39f33f11","413":"bcaed8e0","606":"61395a75"}[chunkId] + ".chunk.css";
};